<template>
  <v-dialog v-model="show" transition="dialog-bottom-transition" :overlay="false" max-width="800px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>fa-user-tie</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Add a new introducer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text>
        <v-form lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Account Name" v-model="details.business.commercialName"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6></v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field label="First Name" v-model="details.firstName"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Last Name" v-model="details.lastName"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Email" v-model="details.email"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Phone" v-model="details.phone"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address Line 1"
                  v-model="details.business.businessLocation.locationLine1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address Line 2"
                  v-model="details.business.businessLocation.locationLine2"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address Line 3"
                  v-model="details.business.businessLocation.locationLine3"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address Line 4"
                  v-model="details.business.businessLocation.locationLine4"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address Line 5"
                  v-model="details.business.businessLocation.locationLine5"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Post Code" v-model="details.business.businessLocation.postcode"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-btn color="accent" @click.native="register">Save</v-btn>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import registrationAPI from '@/api/registration';
import { mapActions } from 'vuex';
import _ from 'lodash';

const detailDefaults = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  isLimited: false,
  business: {
    commercialName: '',
    businessLocation: {
      locationLine1: '',
      locationLine2: '',
      locationLine3: '',
      locationLine4: '',
      locationLine5: '',
      postcode: ''
    },
    type: 'introducer'
  }
};

export default {
  name: 'new-introducer',
  props: ['show'],
  data: () => ({
    details: _.cloneDeep(detailDefaults)
  }),
  computed: {
    ...mapActions(['getAccountsList'])
  },
  methods: {
    clearRegistration() {
      this.details = _.cloneDeep(detailDefaults);
    },
    register() {
      registrationAPI
        .registerBusiness(this.details)
        .then(() => this.getAccountsList())
        .then(this.closeDialog());
    },
    closeDialog() {
      this.clearRegistration();
      this.$emit('update:show', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
